
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmTimeProgress,
  VmCurrentTime,
  VmTime,
  VmEndTime 
} from '@vime/core';

import { define } from '../lib';
  

const TimeProgressInputs: string[] = [
  'separator',
  'alwaysShowHours',
];

const TimeProgressMethods: string[] = [
  
];

const TimeProgressOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface TimeProgress extends Components.VmTimeProgress {}

@ProxyCmp({
  inputs: TimeProgressInputs,
  methods: TimeProgressMethods,
})
@Component({
  selector: 'vm-time-progress',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: TimeProgressInputs,
  outputs: TimeProgressOutputs,
})
export class TimeProgress {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-time-progress', VmTimeProgress);
    define('vm-current-time', VmCurrentTime);
    define('vm-time', VmTime);
    define('vm-end-time', VmEndTime);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  